import { render } from "./sovdavi.vue?vue&type=template&id=39f07518"
import script from "./sovdavi.vue?vue&type=script&lang=js"
export * from "./sovdavi.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/tabibekhanevade-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__